<vb-ui-toggle-content-display [minItems]="10" [totalItems]="tags.length">
	<div layout="row">
		<span #vbUiToggleItem *ngFor="let tag of tags" class="tag-item" [ngClass]="styles.item">
			<a *ngIf="!noLinks; else tagName" [uiSref]="PORTAL_MEDIA_SEARCH_STATE" [uiParams]="{q: tag}">
				{{tag}}
			</a>
			<ng-template #tagName>{{tag}}</ng-template>
		</span>
	</div>
</vb-ui-toggle-content-display>
